import { h } from 'preact';

interface ProductTitleProps {
  title: string;
}

/**
 * ProductTitle - Displays product title with line clamping
 * 
 * **Features:**
 * - Limits title to 2 lines with ellipsis
 * - Uses Inter Tight font family
 * - Responsive text sizing
 * 
 * @param title - Product title text
 * @returns JSX element
 */
const ProductTitle = ({ title }: ProductTitleProps) => {
  return (
    <h2 className="text-giftory-midnight text-base md:text-lg font-bold font-inter-tight !leading-[1.375rem] md:!leading-[1.5rem] line-clamp-2">
      {title}
    </h2>
  );
};

export default ProductTitle; 